
// English translations (default language)
export const en: Record<string, string> = {
  // These are empty since English is the default language
  // We just need keys for reference
};
